module.exports = __webpack_public_path__ + "static/img/c22.6b88768.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c22.jpg
// module id = 268
// module chunks = 0 1 2 3 4 5 6 7 8 9